import { AnalyticsEvent } from 'analytics';
import { TroubleshootEventType } from 'Workspace/TelemetryEvents/TelemetryEventTypes';

const code = 'WSUI_TROUBLESHOOT';

interface TroubleshootEventMetadata {
	transactionId?: string;
	resourceId?: string;
	resourceName?: string;
	errorMessage?: string;
	remediationAction?: string;
}

const preparePayload = (
	type: TroubleshootEventType,
	metadata?: TroubleshootEventMetadata
): AnalyticsEvent => ({
	type,
	code,
	...metadata,
});

export const TroubleshootEventPayload = {
	closeOnError: (data: TroubleshootEventMetadata): AnalyticsEvent =>
		preparePayload(TroubleshootEventType.CloseOnError, data),
	copyDetails: (data: TroubleshootEventMetadata): AnalyticsEvent =>
		preparePayload(TroubleshootEventType.CopyDetails, data),
	getLogs: (data: TroubleshootEventMetadata): AnalyticsEvent =>
		preparePayload(TroubleshootEventType.GetLogs, data),
	downloadLogs: (data: TroubleshootEventMetadata): AnalyticsEvent =>
		preparePayload(TroubleshootEventType.DownloadLogs, data),
	fixIsssue: (data: TroubleshootEventMetadata): AnalyticsEvent =>
		preparePayload(TroubleshootEventType.FixIssue, data),
};
